import { DELIVERY_OPTION_KNOWLEDGE_BASE_URLS } from '@/constants/knowledgeBaseUrls';
import { Logger } from '@/utils/logger';
import type { DELIVERY_OPTION, DELIVERY_OPTIONS } from '@montugroup/circuit-shared';
import { Alert, AlertTitle, Link, Typography, ViewObserver } from '@montugroup/design-system';
import { useEffect } from 'react';

const logger = new Logger('OrderHistoryPresenceAlert');

export const OrderHistoryPresenceAlert = ({
  deliveryOptionName,
}: {
  deliveryOptionName: (typeof DELIVERY_OPTIONS)[DELIVERY_OPTION]['name'];
}) => {
  const helpLink = DELIVERY_OPTION_KNOWLEDGE_BASE_URLS[deliveryOptionName];

  useEffect(() => {
    if (!helpLink) {
      logger.critical('missing helpLink', {
        deliveryOptionName,
      });
    }
  }, [deliveryOptionName, helpLink]);

  return (
    <Alert severity="info" sx={{ width: '100%' }} data-dd-privacy="allow">
      <ViewObserver id={'order-history-presence-alert'}>
        <AlertTitle sx={{ fontWeight: 'bold' }}>You&apos;ll need to be available to receive your order</AlertTitle>
        <Typography variant="body2">
          Someone must be home to receive your medication.{' '}
          {helpLink && (
            <Link id="shipping_presence_alert_help_link" href={helpLink} target="_blank" rel="noopener noreferrer">
              Learn more.
            </Link>
          )}
        </Typography>
      </ViewObserver>
    </Alert>
  );
};
